<template>
  <div id="home">
    <campaign-banner />
    <section>
      <v-parallax
        :src="require(`@/assets/images/calculator-banner.png`)"
        height="400"
        alt="Photo by StellrWeb on Unsplash"
      >
        <v-container>
          <v-layout column align-end justify-center>
            <img
              class="mb-2"
              src="@/assets/images/c-logo.png"
              alt="Vuetify.js"
              height="100"
            />
            <h1 class="mb-2 display-1">Cost of Poor Quality Calculator</h1>
            <div class="subheading mb-4">
              Powered by
              <a href="https://leanrevisions.com" class="white--text lighten-1"
                >Lean Revisions</a
              >
            </div>
            <v-row v-if="userIsLoggedIn">
              <v-btn
                color="blue lighten-1"
                dark
                large
                @click="renderCalculator"
              >
                <v-icon small class="mr-2">fas fa-calculator</v-icon>
                Load Calculator
              </v-btn>
            </v-row>
            <v-row v-else>
              <v-btn class="mr-2" large :to="{ name: 'register' }">
                Get Started
              </v-btn>
              <v-btn color="blue lighten-1" dark large :to="{ name: 'login' }">
                <v-icon small class="mr-2">fas fa-user</v-icon>
                Log In
              </v-btn>
            </v-row>
          </v-layout>
        </v-container>
      </v-parallax>
    </section>

    <section>
      <v-layout column wrap class="my-12" align-center>
        <v-flex xs12 sm4 class="mb-12">
          <div class="text-center">
            <h2 class="headline">
              A calculator to help you discover your saving potential
            </h2>
            <span class="subheading">
              Created by the experts in six sigma
            </span>
          </div>
        </v-flex>
        <v-flex xs12>
          <v-divider></v-divider>
          <v-container grid-list-xl>
            <v-layout row wrap align-center justify-center>
              <v-flex xs12 sm6 md4>
                <v-card outlined class="transparent">
                  <v-card-text class="text-center">
                    <v-icon x-large class="blue--text text--lighten-1"
                      >fas fa-clock</v-icon
                    >
                  </v-card-text>
                  <v-card-title primary-title class="layout justify-center">
                    <div class="headline text-center">
                      Complete in 10 Minutes
                    </div>
                  </v-card-title>
                  <v-card-text>
                    We developed this Cost of Poor Quality (COPQ) tool for your
                    convenience. Take 10 minutes to fill in applicable operating
                    fields to understand where operating cost are impeding your
                    organizations ability to grow, innovate and retain customer
                    loyalty.
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-card outlined class="transparent">
                  <v-card-text class="text-center">
                    <v-icon x-large class="blue--text text--lighten-1"
                      >fas fa-poll</v-icon
                    >
                  </v-card-text>
                  <v-card-title primary-title class="layout justify-center">
                    <div class="headline">Review Dashboard</div>
                  </v-card-title>
                  <v-card-text>
                    Uncover of your organizations opportunities to identify and
                    eliminate 10% - 40% of your operating cost and grow your
                    financial margins. After using this assessment tool, find
                    out how Lean Six Sigma methodology can help you create more
                    capital gains.
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-card outlined class="transparent">
                  <v-card-text class="text-center">
                    <v-icon x-large class="blue--text text--lighten-1"
                      >fas fa-print</v-icon
                    >
                  </v-card-text>
                  <v-card-title primary-title class="layout justify-center">
                    <div class="headline text-center">Print Summary</div>
                  </v-card-title>
                  <v-card-text>
                    Share your findings with your team by printing out your
                    results or saving it to your computer for future review and
                    analysis. When you're ready, a Lean Six Sigma expert can
                    look through your analysis with you to help strategize how
                    to start cutting these newly discovered costs.
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout justify-center>
              <v-flex xs12 md10 lg8>
                <h2 class="headline text-center my-4">
                  What is Cost of Poor Quality?
                </h2>
                <div class="iframe-container">
                  <iframe
                    src="https://www.youtube.com/embed/UXOqICTxET0"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </section>

    <section>
      <v-parallax
        :src="require(`@/assets/images/seattle-1.jpg`)"
        height="380"
        alt="Photo by Zhifei Zhou on Unsplash"
      >
        <v-layout column align-center justify-center>
          <img
            src="@/assets/images/LeanRevisions-hLogo.png"
            alt="lean revisions logo"
            width="350"
          />
          <div class="headline white--text mb-4 text-center">
            Leaner thinking. Better results.
          </div>
          <em>Reach out to a six sigma expert today</em>
          <v-btn
            class="mt-12"
            color="blue lighten-1"
            dark
            large
            @click="$emit('show-contact-us')"
          >
            Contact Us
          </v-btn>
        </v-layout>
      </v-parallax>
    </section>

    <section>
      <v-container grid-list-xl>
        <v-layout row wrap justify-center class="my-12">
          <v-flex xs12 sm4>
            <v-card outlined class="transparent">
              <v-card-title primary-title class="layout justify-center">
                <div class="headline">Lean Revisions</div>
              </v-card-title>
              <v-card-text>
                Lean Revisions along with their X1 Learning System offers
                high-impact, low cost solutions on a scalable basis, allowing
                for rapid results and a legacy of continuous improvement within
                any industry or organization.
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 sm4 offset-sm1>
            <v-card outlined class="transparent">
              <v-card-text class="text-center">
                <div>
                  <v-btn
                    dark
                    large
                    href="https://leanrevisions.com"
                    color="red lighten-1 ma-1"
                  >
                    Find out more!
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
  </div>
</template>

<script>
import CampaignBanner from "@/components/CampaignBanner.vue";

import GeneralService from "@/services/GeneralService";

export default {
  name: "HomePage",
  components: {
    CampaignBanner,
  },
  props: {
    thePage: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    userIsLoggedIn() {
      return this.$store.getters.userIsLoggedIn;
    },
  },
  watch: {
    thePage: {
      immediate: true,
      handler(val) {
        this.$emit("update:page", val);
      },
    },
  },
  created() {
    GeneralService.scrollTop();
  },
  methods: {
    renderCalculator() {
      this.$router.push({
        name: "calculator",
        params: {
          thePage: 2,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.iframe-container {
  overflow: hidden;
  padding-top: 56.25%;
  position: relative;
}

.iframe-container iframe {
  border: 0;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

/* 4x3 Aspect Ratio */
.iframe-container-4x3 {
  padding-top: 75%;
}
</style>
